import React from "react"

import Dialog from "@base/Dialog";

import EmailPage from "@pages/Pendencia/Email";

export const EmailDialog = (props) => {
	return (
		<Dialog
			maxWidth={"md"}
			fullWidth={true}
			closeDialog={props.handleClose}
			openDialog={props.open}
			title={`Detalhes do Email Enviado - Pendência #${props.id}`}
		>
			<EmailPage 
                id={props.id}
            />
		</Dialog>
	);
}

export default EmailDialog;
